import { ProcessOperationType } from 'types/Process';
import { ProcessExcelConfig } from './types';

/** Config Excel y payload para DEVOLUCION_INTERESES */
// eslint-disable-next-line import/prefer-default-export
export const DEVOLUCION_INTERESES_CONFIG: ProcessExcelConfig = {
  operationType: ProcessOperationType.DEVOLUCION_INTERESES,
  promotionColIndex: 0,
  accountNameColIndex: 2,
  payloadColumns: {
    investmentAccountId: { colIndex: 1, type: 'string', label: 'Cuenta de inversión' },
    amount: { colIndex: 9, type: 'number', label: 'Monto total de intereses' },
    withHoldingOnInterest: {
      colIndex: 10,
      type: 'number',
      label: 'Retención sobre intereses',
    },
    netAmountToRecieve: {
      colIndex: 13,
      type: 'number',
      label: 'Líquido a percibir',
    },
    paymentDate: { colIndex: 14, type: 'date', label: 'Fecha de pago' },
    exercise: { colIndex: 4, type: 'string', label: 'Ejercicio' },
  },
};
